// @ts-nocheck
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import ItemLayout from 'js/components/Item/ItemLayout'
import { NotFound } from 'js/core/NotFound'
import { useSiteStore } from 'js/lib/stores'

import getRefetchQueries from './helpers/getRefetchQueries'
import { NEWS_ITEM } from './Item.queries'

const Item = () => {
    const commentsOnNews = useSiteStore(({ site }) => site.commentsOnNews)
    const { guid, groupGuid } = useParams()

    const { loading, data } = useQuery<any>(NEWS_ITEM, {
        variables: {
            guid,
            groupGuid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { entity, viewer } = data

    const onEdit = `/news/edit/${entity.guid}`
    const onAfterDelete = '/news'
    const refetchQueries = getRefetchQueries(true)

    return (
        <ItemLayout
            viewer={viewer}
            entity={entity}
            refetchQueries={refetchQueries}
            options={{
                author: true,
                publishDate: true,
                views: true,
                save: true,
                likes: true,
                follow: true,
                share: true,
                comments: commentsOnNews,
            }}
            onEdit={onEdit}
            onAfterDelete={onAfterDelete}
        />
    )
}

export default Item
